import editarExpressCheckingForm from './editExpressCheckingFormModel';
const {
  formField: {
    // DATOS AREA
    e_code,
    e_adults,
    e_minors,
    e_arrival,
    e_departure,
    e_bussines,
  },
} = editarExpressCheckingForm;

export default {
  [e_code.name]: '',
  [e_adults.name]: '',
  [e_minors.name]: 0,
  [e_arrival.name]: null,
  [e_departure.name]: null,
  [e_bussines.name]: false,
};
